﻿export class UserHazardModel {
    UserHazardId: number;
    HazardMasterId: number;
    Userid: number;
    CreatedDate: string;
    CreatedBy: number;
    ModifiedDate: string;
    ModifiedBy: number;
}